import { Grid, styled } from "@mui/material";
import React from "react";
import { HandlingTimesFormProps } from "./HandlingTimesFormProps";
import { MdmTabs } from "../../../Layout/Tabs/MdmTabs";
import { SprHandlingTimesDataTable } from "./SprHandlingTimesDataTable";
import { CountryHandlingTimesDataTable } from "./CountryHandlingTimesDataTable";
import { SupplierHandlingTimesDataTable } from "./SupplierHandlingTimesDataTable";
import { DefaultHandlingTimesForm } from "./DefaultHandlingTimesForm";

const MdmSubTabs = styled(MdmTabs)(() => ({
  "& .MuiTabs-indicator": {
    backgroundColor: "black",
  },
  "& .Mui-selected": {
    color: "black",
    fontWeight: "bold",
  },
}));

export const OdcHandlingTimesForm = (props: HandlingTimesFormProps) => {
  return (
    <Grid container columnSpacing={1} rowSpacing={2} style={{ flexGrow: 1 }}>
      <DefaultHandlingTimesForm {...props} />
      <Grid item xs={12}>
        <MdmSubTabs
          tabs={[
            {
              index: 0,
              label: "COUNTRY",
              content: <CountryHandlingTimesDataTable />,
            },
            {
              index: 1,
              label: "SUPPLIER",
              content: <SupplierHandlingTimesDataTable />,
            },
            {
              index: 2,
              label: "SPR",
              content: <SprHandlingTimesDataTable />,
            },
          ]}
        />
      </Grid>
    </Grid>
  );
};
